export default __webpack_public_path__ + "static/media/icon_help.72200155.svg";